"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Tabs.scss");
var _trimbleGlobe = _interopRequireDefault(require("../../images/trimble-globe.jpg"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useWindowSize = _interopRequireDefault(require("../../utils/hooks/useWindowSize"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function jumpToContent(contentID) {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    if (window.innerWidth <= 900) {
      document.documentElement.style.scrollBehavior = "smooth";
      document.getElementById(contentID).scrollIntoView();
      document.documentElement.style.scrollBehavior = null;
    }
  }
}
const TabContent = _ref => {
  let {
    index,
    isActive,
    children,
    contentfulId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `content-entry nested-content ${isActive && "active"}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, children);
};
const NavEntry = _ref2 => {
  let {
    index,
    isActive,
    setIndex,
    header,
    description,
    image,
    displayThumbnails,
    contentID,
    numberOfTabs,
    contentfulId
  } = _ref2;
  const {
    mouse
  } = (0, _useMouse.default)();
  const tabsNumberForAria = displayThumbnails && numberOfTabs > 4 ? "4" : numberOfTabs;
  let tabsWidth = '';
  if (numberOfTabs >= 4) {
    tabsWidth = "quarter";
  } else if (numberOfTabs === 3) {
    tabsWidth = "one-third";
  } else if (numberOfTabs === 2) {
    tabsWidth = "half";
  } else if (numberOfTabs === 1) {
    tabsWidth = "full";
  }
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => {
      setIndex(index);
      jumpToContent(contentID);
    },
    className: `nav-entry ${`nav-entry--${tabsWidth}`} ${isActive && "active"} ${mouse ? "" : "focus"}`,
    "aria-selected": isActive,
    "aria-label": isActive ? `Selected Tab ${index + 1} of ${tabsNumberForAria}` : `Unselected Tab ${index + 1} of ${tabsNumberForAria}`,
    "aria-controls": `Selected tab ${index + 1} of ${tabsNumberForAria}: ${header}`,
    tabIndex: mouse ? "" : 0,
    role: "tab",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, displayThumbnails && /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-thumbnail"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image?.url ? image?.url : _trimbleGlobe.default,
    alt: image?.alt ? image?.alt : "Trimble Logo",
    "data-sb-field-path": "image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-text"
  }, header && /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-title",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  }), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-subtitle",
    "data-sb-field-path": "description"
  }, description)));
};
const MobileTopNavEntry = _ref3 => {
  let {
    tab,
    contentfulId
  } = _ref3;
  const {
    size
  } = (0, _useWindowSize.default)();
  if (size === "mobile") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "nav-text-top-mobile",
      "data-sb-object-id": contentfulId ? contentfulId : null
    }, tab?.header && /*#__PURE__*/_react.default.createElement("div", {
      className: "nav-title",
      "data-sb-field-path": "header"
    }, tab?.header)), /*#__PURE__*/_react.default.createElement("div", {
      className: "nav-text-top-mobile__arrow"
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
const Tabs = _ref4 => {
  let {
    orientation,
    variant,
    displayThumbnails,
    tabs,
    paddingClass,
    index,
    contentfulId
  } = _ref4;
  const {
    size
  } = (0, _useWindowSize.default)();
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);
  let orientationClass = "top";
  let navClasses = "text-entries light";
  let thumbnails = displayThumbnails;
  if (orientation === "bottom") {
    orientationClass = orientation;
  } else if (orientation === "left") {
    orientationClass = orientation;
  } else if (orientation === "right") {
    orientationClass = orientation;
  }
  if (variant === "text-background-dark") {
    navClasses = "text-entries dark";
  } else if (variant === "thumbnail-round") {
    navClasses = "thumbnails round";
    thumbnails = true;
  } else if (variant === "thumbnail-square") {
    navClasses = "thumbnails square";
    thumbnails = true;
  }
  const renderTopTab = tabs.find((tab, index) => {
    if (index === activeIndex) {
      return tab;
    }
  });
  const contentID = `content-entries-${(0, _react.useId)("id-")}-${index}`;
  const mobileThumbnailTop = orientation !== "bottom" && variant === "thumbnail-square" || orientation !== "bottom" && variant === "thumbnail-round";
  return tabs?.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: `tabs-container ${orientationClass} ${navClasses} ${paddingClass}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: contentID,
    className: "tabs-container__mobile-title"
  }, !mobileThumbnailTop && /*#__PURE__*/_react.default.createElement(MobileTopNavEntry, {
    tab: renderTopTab,
    displayThumbnails: thumbnails,
    orientation: orientationClass,
    contentfulId: contentfulId
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `nav-entries ${navClasses} ${orientationClass}`,
    role: "tablist"
  }, tabs.map((tab, index) => /*#__PURE__*/_react.default.createElement(NavEntry, {
    key: `${contentID}-tab-${index}`,
    index: index,
    isActive: index === activeIndex ? true : false,
    setIndex: setActiveIndex,
    header: tab?.header,
    description: tab?.description,
    image: tab?.image,
    displayThumbnails: thumbnails,
    contentID: contentID,
    numberOfTabs: tabs.length,
    contentfulId: tab?.contentfulId
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `content-entries ${orientationClass}`,
    id: size === "tablet" ? contentID : "",
    role: "tabpanel",
    "aria-labelledby": contentID
  }, tabs.map((tab, index) => /*#__PURE__*/_react.default.createElement(TabContent, {
    key: `${contentID}-content-${index}`,
    index: index,
    isActive: index === activeIndex ? true : false,
    children: tab?.content,
    contentfulId: tab?.contentfulId
  })))) : null;
};
var _default = Tabs;
exports.default = _default;
Tabs.propTypes = {
  orientation: _propTypes.default.string,
  variant: _propTypes.default.string,
  displayThumbnails: _propTypes.default.bool,
  tabs: _propTypes.default.array,
  paddingClass: _propTypes.default.string,
  index: _propTypes.default.number
};